import i18n from "i18next";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FilterItem from "./FilterItem";
import { getFilterValue } from "./FilterHelpers";

export default class FiltersRow extends PureComponent {
  static propTypes = {
    onClearFilters: PropTypes.func.isRequired,
    onDeleteFilter: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired,
    customersSelections: PropTypes.array,
    filters: PropTypes.object
  };

  static defaultProps = {
    customersSelections: [],
    filters: {}
  };

  renderFilterItems = filterName => {
    const filter = this.props.filters[filterName];

    if (Array.isArray(filter)) {
      return filter.map(value => (
        <FilterItem key={value} filter={getFilterValue(this.props.customersSelections, filterName, value)} onClick={this.props.onDeleteFilter} />
      ));
    }

    if (filter) {
      return <FilterItem key={filter} filter={{ label: filter, value: filter }} onClick={this.props.onDeleteFilter} />;
    }

    return null;
  };

  render() {
    return (
      <div className="sorted-list__filters">
        <div className="sorted-list__filters-content">{Object.keys(this.props.filters).map(filterName => this.renderFilterItems(filterName))}</div>
        <a role="presentation" className="sorted-list__filters-reset --red" onClick={this.props.onClearFilters}>
          {i18n.t("filters.clearAll")}
        </a>
        <a role="presentation" className="sorted-list__filters-reset --green --large" onClick={this.props.onResetFilters}>
          {i18n.t("filters.resetToDefault")}
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/FiltersRow.js